import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Dashboard from "../components/Dashboard";
import { PageContainer } from "../styles/HomeStyles";
import { getSession } from "../services/api";

const Home = () => {
  const [access, setAccess] = useState("checking");

  useEffect(() => {
    let mounted = true;
    getSession()
      .then((authenticated) => {
        if (mounted) setAccess(authenticated ? "granted" : "denied");
      })
      .catch(() => {
        if (mounted) setAccess("unavailable");
      });
    return () => { mounted = false; };
  }, []);

  if (access === "checking") return <PageContainer>Verificando acesso...</PageContainer>;
  if (access === "unavailable") {
    return <PageContainer>Não foi possível conectar à API de monitoramento.</PageContainer>;
  }
  if (access === "denied") return <Navigate to="/" replace />;

  return (
    <PageContainer>
      <Dashboard />
    </PageContainer>
  );
};

export default Home;
